export enum TextSymbol {
  NO_BREAK_SPACE = '\u00A0',
}
